import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDialogImagemAmpliada {
	images: Array<{ image: string; thumbImage?: string }>;
	index: number;
}

@Component({
	standalone: false,
	selector: 'app-imagem-ampliada',
	templateUrl: './imagem-ampliada.component.html',
	styleUrls: ['./imagem-ampliada.component.css']
})
export class ImagemAmpliadaComponent implements AfterViewInit {

	public data = inject<IDialogImagemAmpliada>(MAT_DIALOG_DATA);
	public dialogRef = inject<MatDialogRef<ImagemAmpliadaComponent>>(MatDialogRef);

	@ViewChild('lightboxSwiper') swiperRef!: ElementRef<any>;

	public images: Array<{ image: string; thumbImage?: string }>;
	public index: number;

	constructor() {
		this.images = this.data.images ?? [];
		this.index = this.data.index ?? 0;
	}

	ngAfterViewInit() {
		this.posicionarSlide();
	}

	private posicionarSlide() {
		const swiperEl: any = this.swiperRef?.nativeElement;
		if (!swiperEl) {
			return;
		}
		const aplicar = () => {
			const swiper = swiperEl.swiper;
			if (swiper && typeof swiper.slideTo === 'function') {
				swiper.slideTo(this.index, 0, false);
			}
		};
		if (swiperEl.swiper) {
			aplicar();
		} else {
			setTimeout(aplicar, 0);
		}
	}

	fechar() {
		this.dialogRef.close();
	}
}
